const action = 'ONBOARDING_CREATE_WORKSPACE';
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

// payload: { body: <POST /workspace body>, meta: { name, useCase, goalText } }
export const fetchRequest = (payload) => ({
  type: REQUEST,
  payload,
});

// payload: { id, name, useCase, goalText }
export const fetchSuccess = (payload) => ({
  type: RESPONSE,
  payload,
});

export const fetchFailure = (payload) => ({
  type: FAILURE,
  payload,
});

export const clear = () => ({
  type: CLEAR,
});
